import { render, staticRenderFns } from "./DisplayAnswer.vue?vue&type=template&id=0f0410b0"
import script from "./DisplayAnswer.vue?vue&type=script&lang=ts"
export * from "./DisplayAnswer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports